'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash.frompairs');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _selectTable = require('react-table/lib/hoc/selectTable');

var _selectTable2 = _interopRequireDefault(_selectTable);

var _TableHeader = require('./TableHeader');

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TablePagination = require('./TablePagination');

var _TablePagination2 = _interopRequireDefault(_TablePagination);

var _TableSelect = require('./TableSelect');

var _TableSelect2 = _interopRequireDefault(_TableSelect);

var _TableSpinner = require('./TableSpinner');

var _TableSpinner2 = _interopRequireDefault(_TableSpinner);

var _TableNoData = require('./TableNoData');

var _TableNoData2 = _interopRequireDefault(_TableNoData);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CheckboxReactTable = (0, _selectTable2.default)(_reactTable2.default);
var defaultPageSizes = [10, 20, 50, 100];

var Table = function (_PureComponent) {
  _inherits(Table, _PureComponent);

  function Table() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Table.__proto__ || Object.getPrototypeOf(Table)).call.apply(_ref, [this].concat(args))), _this), _this.tableRef = null, _this.state = {
      resolvedData: _this.props.data,
      // eslint-disable-line react/no-unused-state
      selections: {}
    }, _this.getVisibleData = function () {
      if (!_this.tableRef) {
        return _this.props.data || [];
      }

      var resolvedState = _this.tableRef.getWrappedInstance().getResolvedState();

      var pageStart = resolvedState.page * resolvedState.pageSize;
      var pageEnd = (resolvedState.page + 1) * resolvedState.pageSize;
      return resolvedState.resolvedData.slice(pageStart, pageEnd);
    }, _this.getVisibleSelections = function () {
      var keyField = _this.props.keyField;
      var selections = _this.state.selections;

      var visibleData = _this.getVisibleData();

      var visibleKeys = visibleData.map(function (row) {
        var key = row[keyField];
        return [key, selections[key]];
      });
      return (0, _lodash2.default)(visibleKeys);
    }, _this.getPaginationProps = function () {
      var condensed = _this.props.condensed;
      return {
        condensed: condensed
      };
    }, _this.getTableRef = function (tableRef) {
      _this.tableRef = tableRef;
    }, _this.getTheadThProps = function (state, row, column) {
      var sortable = [column.sortable, state.sortable, false].find(function (x) {
        return x != null;
      });
      var sorted = state.sorted.find(function (x) {
        return x.id === column.id;
      });
      return {
        sortable: sortable,
        sorted: sorted
      };
    }, _this.getNoDataProps = function (_ref2) {
      var loading = _ref2.loading;
      return {
        loading: loading
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Table, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          condensed = _props.condensed,
          selectable = _props.selectable;

      var props = _extends({
        ref: this.getTableRef,
        className: (0, _classnames2.default)(className, {
          'table-condensed': condensed
        }),
        // Callbacks for providing custom props to individual components
        getPaginationProps: this.getPaginationProps,
        getTheadThProps: this.getTheadThProps,
        getNoDataProps: this.getNoDataProps,
        ThComponent: _TableHeader2.default,
        // Defaults for pagination
        defaultPageSize: 10,
        pageSizeOptions: defaultPageSizes,
        LoadingComponent: function LoadingComponent(loadingProps) {
          return _react2.default.createElement(_TableSpinner2.default, _extends({}, loadingProps, {
            data: _this2.props.data
          }));
        },
        NoDataComponent: function NoDataComponent(noDataProps) {
          return _react2.default.createElement(_TableNoData2.default, _extends({}, noDataProps, {
            data: _this2.props.data
          }));
        },
        PaginationComponent: _TablePagination2.default,
        // Selection state and callbacks
        selectType: 'checkbox',
        selectWidth: 73,
        // Magic number that is 2 times left padding plus checkbox width.
        SelectAllInputComponent: _TableSelect2.default,
        SelectInputComponent: _TableSelect2.default,
        style: {
          position: 'relative'
        }
      }, this.props);

      return selectable ? _react2.default.createElement(CheckboxReactTable, props) : _react2.default.createElement(_reactTable2.default, props);
    }
  }]);

  return Table;
}(_react.PureComponent);

exports.default = Table;
Table.propTypes = {
  className: _propTypes2.default.string,
  condensed: _propTypes2.default.bool,
  selectable: _propTypes2.default.bool,
  data: _propTypes2.default.any,
  // eslint-disable-line react/forbid-prop-types
  keyField: _propTypes2.default.any // eslint-disable-line react/forbid-prop-types

};